// CANONICAL COPY (GH #7115). src/constants/obligations/obl-asset-inventory.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-asset-inventory',
  title: 'Verify asset inventory is maintained',
  description:
    'Confirm that an inventory of information assets and associated assets exists and is kept up to date. Check that all assets have designated owners.',
  category: 'assets',
  scfIds: ['SCF-AST-001'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    { type: 'asset-inventory-exists', description: 'Employee asset records exist in the system' },
    { type: 'document-published', description: 'Asset management policy is published' },
    { type: 'asset-owners-assigned', description: 'All active assets have a designated owner' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
